<!-- title & avatar -->
<div
	class="px-2 pt-4 pb-2 md:bg-gray-50 md:border-b md:px-6 md:pt-6 md:pb-6 rounded-t-md"
>
	<div class="flex items-center gap-2 md:gap-4">
		<div
			class="relative flex-shrink-0 hidden rounded-full md:flex h-9 w-9 md:h-10 md:w-10"
		>
			<img
				[ngSrc]="(review().avatar ? review().avatar : avatar()) | cdn"
				fill
				alt="User Avatar"
			/>
		</div>
		<div>
			<div class="flex gap-2 md:block">
				<div
					class="relative flex-shrink-0 rounded-full md:hidden h-9 w-9 md:h-10 md:w-10"
				>
					<img
						[ngSrc]="(review().avatar ? review().avatar : avatar()) | cdn"
						fill
						alt="User Avatar"
					/>
				</div>
				@if (review().title) {
					<h2
						class="pt-px text-xl font-bold tracking-tight text-black"
						[innerHtml]="
							review().title | ucEntities | highlightSearch: searchTerm()!
						"
					></h2>
				}
				@if (!review().title) {
					<h2
						class="pt-px text-xl italic font-bold tracking-tight text-gray-400"
					>
						No Title Provided
					</h2>
				}
			</div>

			<div class="mt-1 -ml-1 text-base">
				<span class="flex flex-wrap font-semibold text-gray-400 align-center">
					<uc-star-rating [rating]="review().rating" />
					@if (review().rating % 1 === 0) {
						<span class="ml-1 -mt-0.5">
							<span>({{ review().rating | number: '1.0-0' }})</span>
							<span class="ml-1">&middot;</span>
						</span>
					}
					@if (review().rating % 1 !== 0) {
						<span class="ml-1 -mt-0.5">
							<span>({{ review().rating | number: '1.1-1' }})</span>
							<span class="ml-1">&middot;</span>
						</span>
					}
					@if (review().username) {
						<span class="ml-1 -mt-0.5 flex capitalize">
							<span>By {{ review().username | lastNameInitial }}</span
							><span class="ml-1">&middot;</span>
						</span>
					}
					@if (review().subject) {
						<span class="ml-1 -mt-0.5">
							<span
								[innerHtml]="
									review().subject!
										| ucEntities
										| highlightSearch: searchTerm()!
								"
							></span>
							@if (review().published_at) {
								<span class="ml-1">&middot;</span>
							}
						</span>
					}
					@if (review().published_at) {
						<span class="ml-1 -mt-0.5">
							{{ review().published_at | date: 'MMM YYY' }}
						</span>
					}
				</span>
			</div>
		</div>
	</div>
</div>
